export default {
    GetDiscounts: 'api/private/discount',
    AddDiscount: 'api/private/discount',
    DeleteDiscount: 'api/private/discount',
    UpdateDiscount: 'api/private/discount',
    GetDiscountById: 'api/private/discount',
  };
  